<template>
  <el-dialog title="一键检查结果" :visible.sync="dialogInfo.show" width="860px" :close-on-click-modal="false"
    @close="closeDia" destroy-on-close>
    <div>
      <butn class="export-btn" btntype="primary" @click.native="exportHandle" title="导出"></butn>
      <el-table :data="resultData" border style="width: 100%" :header-cell-style="{ background: '#DCE7FA' }"
        height="350px">
        <el-table-column prop="type" label="类型" min-width="80" align="center">
        </el-table-column>
        <el-table-column prop="name" label="姓名" min-width="120" align="center">
        </el-table-column>
        <el-table-column prop="unitPosition" label="单位及职务" min-width="180" align="center">
        </el-table-column>
        <el-table-column prop="errorMsg" label="异常说明" min-width="240" align="center">
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import ExportJsonExcel from 'js-export-excel';
export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {
          show: true,
        };
      },
    },
  },
  data() {
    return {
      resultData: [],
    };
  },
  created() {
    this.resultData = this.dialogInfo.list || [];
  },
  methods: {

    exportHandle() {
      if (this.resultData && this.resultData.length > 0) {
        const dataTable = this.resultData.map(item => {
          return {
            "类型": item.type,
            "姓名": item.name,
            "单位及职务": item.unitPosition,
            "异常说明": item.errorMsg
          }
        });
        this.exportToExcel(dataTable);
      }
    },

    exportToExcel(dataTable) {
      var option = {};
      option.fileName = "一键检查结果";
      option.datas = [
        {
          sheetData: dataTable,
          sheetName: "sheet",
          sheetFilter: [
            "类型",
            "姓名",
            "单位及职务",
            "异常说明"
          ],
          sheetHeader: [
            "类型",
            "姓名",
            "单位及职务",
            "异常说明"
          ],
          columnWidths: [10, 10, 10, 20]
        }
      ];
      var toExcel = new ExportJsonExcel(option);
      toExcel.saveExcel();
    },

    closeDia() {
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.export-btn {
  float: right;
  margin-bottom: 16px;
}
</style>
